var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.34 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.35,88.52a28,28,0,0,1,28-28h0a28,28,0,0,1,28,28v101a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28Z",
    transform: "translate(-3 -3.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.35,88.52a28,28,0,0,1,28-28h0a28,28,0,0,1,28,28v101a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28Z",
    transform: "translate(-3 -3.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.35,189.52a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28v-56a34,34,0,0,1,34-34h22Z",
    transform: "translate(-3 -3.52)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.35,83.52h40a40,40,0,0,0,40-40h0a40,40,0,0,0-40-40h0a40,40,0,0,0-40,40Z",
    transform: "translate(-3 -3.52)",
    style: {
      fill: "#3477dc"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.47,182.3c-5.3-5.83-27.36,6.93-33.91-6.93,30.93-3,46.92-43.1,18.9-69.84-33.74-32.2-100.9-5.09-103.38,48-1.52,32.56,20.19,64.11,57.42,65.85C108.06,221.63,126.78,188.12,121.47,182.3Z",
    transform: "translate(-3 -3.52)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8a4d82045b437e46c7860c3d6b41dab.svg";
export { ForwardRef as ReactComponent };